export const specialties = [
  {
    title: "Ambulatory Surgery",
    icon: "/specialities-icons/ambulatory-surgery.webp",
  },
  {
    title: "Mental Health",
    icon: "/specialities-icons/mental-health.webp",
  },
  {
    title: "Internal Medicine",
    icon: "/specialities-icons/internal-medicine.webp",
  },
  {
    title: "Allergy and Immunology",
    icon: "/specialities-icons/allergy-and-immunology.webp",
  },
  {
    title: "Pathology",
    icon: "/specialities-icons/pathology.webp",
  },
  {
    title: "Pain Management",
    icon: "/specialities-icons/pain-management.webp",
  },
  {
    title: "Obstetrics & Gynecology",
    icon: "/specialities-icons/obstetrics-and-gynecology.webp",
  },
  {
    title: "Neurology",
    icon: "/specialities-icons/neurology.webp",
  },
  {
    title: "Podiatry",
    icon: "/specialities-icons/podiatry.webp",
  },
  {
    title: "Pediatric",
    icon: "/specialities-icons/pediatric.webp",
  },
  {
    title: "Gastroenterology",
    icon: "/specialities-icons/gastroenterology.webp",
  },
  {
    title: "Cardiology",
    icon: "/specialities-icons/cardiology.webp",
  },
  {
    title: "Ophthalmology",
    icon: "/specialities-icons/ophthalmology.webp",
  },
  {
    title: "Orthopedic",
    icon: "/specialities-icons/orthopedic.webp",
  },
  {
    title: "Urology",
    icon: "/specialities-icons/urology.webp",
  },
  {
    title: "Urgent Care",
    icon: "/specialities-icons/urgent-care.webp",
  },
];
